// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2808":"a782f0cb","3035":"ce65b6ac","5618":"6f2bf078","6762":"7c22f698"}[chunkId] + ".chunk.css";
};